import { DoneAll, Task, TaskIcon } from '@lyearn/icons';
import RESOURCE_TYPE_LABEL_CONFIG from '@/modules/content/config/label';
import { ContentConfigProps } from '@/modules/content/types';
import routes from '@/pages/corporate/routes';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

const config: ContentConfigProps = {
  routes: {
    create: routes.TaskCreator,
    edit: routes.TaskEditor,
    duplicate: routes.TaskDuplicate,
    manageDetails: routes.AdminTaskDetails,
    details: routes.TaskDetails,
  },
  label: RESOURCE_TYPE_LABEL_CONFIG[ResourceTypeEnum.Task],
  icons: {
    Type: Task,
    Create: DoneAll,
    Icon: TaskIcon,
    getContentImage: (content: ContentEntity) => ({ image: content.cover?.url! }),
  },
};

export default config;
